import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import i18n, { initializeI18n } from './plugins/i18n/index'

// Initialize i18n
initializeI18n()

// Log i18n status
console.log('[i18n DEBUG] i18n initialized with locale:', i18n.global.locale.value)
console.log('[i18n DEBUG] reports.table.category key exists:', i18n.global.te('reports.table.category'))
console.log('[i18n DEBUG] i18n message count:', Object.keys(i18n.global.messages.value[i18n.global.locale.value] || {}).length)
console.log('[i18n DEBUG] Available locales:', i18n.global.availableLocales)

// Add error handler to catch any unhandled errors with locales
window.addEventListener('error', function(event) {
  console.error('[i18n DEBUG] Global error:', event.error?.message || event.message);
});

const app = createApp(App)

app.use(ElementPlus)
app.use(router)
app.use(i18n)
app.mount('#app')
